import script from "./ContentView.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentView.vue?vue&type=script&setup=true&lang=js"

import "./ContentView.vue?vue&type=style&index=0&id=22b70a56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22b70a56"]])

export default __exports__